import React from 'react';
import ReactDOM from 'react-dom';
import circular1 from '../../assets/img/circular1.png'
import circular2 from '../../assets/img/circular_2.png'
import PlayCountdown from './PlayCoundown';
import PlayNoCountDown from './PlayNoCountDown';
import PlayAction from './PlayAction';
import { error, httpSuccess, success } from '../../common/errorCode';
import { loadInitAuctionUrl } from '../../common/url';
import { restPostApi } from '../../services/httpService';
import { useSelector } from 'react-redux';
import { store } from '../..';
import { setDataToModal } from '../../actions/modal';
import { OPENNING, PLAY_SHOW_ACTION, PLAY_SHOW_COUNTDOWN, PLAY_SHOW_NO_COUNTDOWN } from '../../common/constant';
import { isNotNull } from '../../common/utils';

const PlayPage = () => {
    const [typePlayShow, setTypePlayShow] = React.useState(PLAY_SHOW_NO_COUNTDOWN);

    const [termInfo, setTermInfo] = React.useState({});
    const [auctionUsers, setAuctionUsers] = React.useState({});
    const [auctionItems, setAuctionItems] = React.useState({});

    const tokenInfo = useSelector((state) => state.SessionReducer);

    // load data
    React.useEffect(() => {
        console.log("PlayAction useEffect");
        // eventAuctionSubmitBus.on("auctionSubmit", (data) => submitAuction(data.data))
        // eventAuctionSubmitBus.remove("auctionSubmit");

        // load data from server
        loadPlayInfo();
    }, []);

    async function loadPlayInfo() {
        let res = await restPostApi(
            loadInitAuctionUrl,
            {
            },
            tokenInfo
        );
        console.log("res: " + JSON.stringify(res));

        if (res != null) {
            console.log("status: " + res.status);

            let message = "Success";
            if (res.status === httpSuccess) {
                console.log("errorCode: " + res.data.errorCode);
                if (res.data.errorCode === success) {
                    if (isNotNull(res.data.data.termInfo)) {
                        setAuctionItems(res.data.data.auctionItems);
                        setAuctionUsers(res.data.data.auctionUsers);
                        setTermInfo(res.data.data.termInfo);

                        // check openning
                        if (res.data.data.termInfo.status === OPENNING) {
                            console.log("PLAY SHOW ACTION");
                            setTypePlayShow(PLAY_SHOW_ACTION);
                        } else {
                            console.log("PLAY SHOW COUNTDOWN");
                            setTypePlayShow(PLAY_SHOW_COUNTDOWN);
                        }
                    } else {
                        console.log("PLAY SHOW NOT COUNTDOWN");
                        setTypePlayShow(PLAY_SHOW_NO_COUNTDOWN);
                    }
                } else {
                    store.dispatch(setDataToModal({
                        type: 'result',
                        dataToModal: {
                            errorCode: res.data.errorCode,
                            message: res.data.message
                        }
                    }));
                }
            } else {
                console.log("message: " + JSON.stringify(res.data));
                message = res.data + ""
                store.dispatch(setDataToModal({
                    type: 'result',
                    dataToModal: {
                        errorCode: res.data.errorCode,
                        message: message
                    }
                }));
            }
        } else {
            console.log("message: Exception");
            store.dispatch(setDataToModal({
                type: 'result',
                dataToModal: {
                    errorCode: error,
                    message: "Exception An error was happened !"
                }
            }));
        }
    }

    return (
        <div>
            <div className="fixed  top-[0%] left-[0%]">
                <img src={circular1} className="" />
            </div>
            <div className="fixed top-[0%] left-[0%]">
                <img src={circular2} className="" />
            </div>

            {
                typePlayShow === PLAY_SHOW_ACTION ?
                    <PlayAction
                        termInfo={termInfo}
                        auctionItems={auctionItems}
                        auctionUsers={auctionUsers}
                    /> :
                    typePlayShow === PLAY_SHOW_COUNTDOWN ?
                        <PlayCountdown
                            termInfo={termInfo}
                        /> :
                        <PlayNoCountDown />
            }




            {/* <PlayCountdown /> */}

            {/* <PlayNoCountDown /> */}

        </div>
    );
}

export default PlayPage;